import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgSignatureSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0H3H8H9V2H8H4V14H10C10.5305 14 11.0392 13.7893 11.4142 13.4142C11.7893 13.0392 12 12.5305 12 12V5.93005V4.93005H14V5.93005V12C14 13.0608 13.5786 14.0783 12.8284 14.8284C12.0783 15.5786 11.0608 16 10 16H3H2V15V1V0ZM11.9357 0.646948L13.3638 2.05456L13.8892 1.49309C13.9603 1.41955 14 1.32184 14 1.22024C14 1.11865 13.9603 1.02098 13.8892 0.947448L13.0388 0.109225C12.9642 0.0391264 12.8651 0 12.7621 0C12.659 0 12.5599 0.0391264 12.4853 0.109225L11.9357 0.646948ZM11.9357 0.646948L8.27122 4.32901L8.00245 5.83146C7.99814 5.85419 7.99953 5.87766 8.00647 5.89975C8.01341 5.92185 8.02572 5.9419 8.04231 5.95825C8.0589 5.9746 8.07924 5.98674 8.10166 5.99358C8.12407 6.00042 8.14788 6.00179 8.17094 5.99754L9.69517 5.73261L13.3593 2.05068L11.9357 0.646948ZM9.6213 10.368C9.66784 10.3703 9.72786 10.3753 9.79371 10.3809C10.0145 10.3995 10.3009 10.4236 10.3648 10.3668C10.5422 10.3377 10.7034 10.2467 10.8198 10.1097C10.9361 9.97274 11 9.79873 11 9.61901C11 9.43928 10.9361 9.26527 10.8198 9.1283C10.7034 8.99132 10.5422 8.90032 10.3648 8.87126H10.1156C10.0853 8.87126 10.0516 8.88148 10.0183 8.89158C9.95302 8.91139 9.88936 8.9307 9.85634 8.87126C9.29802 8.38273 8.62003 8.95115 8.46051 9.50947H8.32092C8.28364 9.10964 8.21704 8.71315 8.12156 8.3231C7.77261 6.86749 7.1246 6.00002 6.41672 6.00002C6.1614 5.99835 5.91511 6.09472 5.72873 6.26923C5.5022 6.47889 5.36629 6.76863 5.34986 7.07686C5.29642 8.12999 5.56792 9.17411 6.12755 10.0678C5.69673 10.2504 5.34381 10.5783 5.13055 10.9947C4.98017 11.3344 4.95896 11.7174 5.07079 12.0716C5.1221 12.3515 5.26989 12.6046 5.48848 12.7867C5.70708 12.9689 5.9826 13.0686 6.26715 13.0686C6.35661 13.0784 6.4469 13.0784 6.53636 13.0686C6.99394 12.9747 7.40954 12.737 7.72274 12.3904L7.83239 12.241C8.08783 11.8728 8.25198 11.4492 8.31106 11.005H8.44055C8.58992 10.9946 8.7399 10.9946 8.88928 11.005C9.36432 11.005 9.54441 10.6557 9.6213 10.368ZM6.4267 7.68489C6.08772 8.2133 6.85535 9.45933 6.85535 9.45933V9.47929C6.85535 9.47929 6.93518 8.13354 6.4267 7.68489ZM6.97498 11.1345C6.67588 11.0248 5.17047 11.6429 6.16747 12.1315V12.1514C6.61613 12.3608 7.5034 11.4136 6.97498 11.1345Z"
      fill={props.color}
    />
  </svg>
);

SvgSignatureSmall.displayName = 'SvgSignatureSmall';
const SignatureSmall = withForgeIconProps(SvgSignatureSmall, {
  name: 'Signature',
  usage: 'Use to represent a signature or a signed document',
  related: 'Approved, Edit',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default SignatureSmall;
